export const isTestMode = () => {
    var url_string = window.location; 
    var url = new URL(url_string.toString());
    var testParam = url.searchParams.get("test");

    return testParam == '1';
}